<template>
  <v-container fluid grid-list-md align-center>
    <v-layout row wrap>

      <v-flex xs12 sm6>
        <v-img
            :src="require('../assets/winterwarriorcollage.jpeg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>
      <v-flex xs12 sm6>
        <v-img
            :src="require('../assets/new2.jpeg')"
            class="elevation-10"
            max-height="600"
            >
        </v-img>
      </v-flex>
      <v-flex xs12 sm6>
        <v-img
            :src="require('../assets/new3.jpeg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>
      <v-flex xs12 sm6>
        <v-img
            :src="require('../assets/new1.jpeg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>
      <v-flex xs12 sm6>
        <v-img
            :src="require('../assets/new6.jpeg')"
            class="elevation-10"
            max-height="600"
            >
        </v-img>
      </v-flex>
      <v-flex xs12 sm6>
        <v-img
            :src="require('../assets/new5.jpeg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>
      <v-flex xs12 sm6>
        <v-img
            :src="require('../assets/snow2.jpg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>
      <v-flex xs12 sm6>
        <v-img
            :src="require('../assets/snow1.jpg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>

      <v-flex xs12 sm4>
        <v-img
            :src="require('../assets/ninja1.jpeg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>
      <v-flex xs12 sm4>
        <v-img
            :src="require('../assets/ninja2.jpg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>
      <!-- <v-flex xs12 sm4>
        <v-img
            :src="require('../assets/outdoor1.jpg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex> -->
      <!-- <v-flex xs12 sm4>
        <v-img
            :src="require('../assets/outdoor3.jpg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex> -->
      <v-flex xs12 sm4>
        <v-img
            :src="require('../assets/tourney.jpg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>
      <v-flex xs12 sm4>
        <v-img
            :src="require('../assets/collage 1.jpg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>
      <v-flex xs12 sm4>
        <v-img
            :src="require('../assets/collage 2.jpg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>
      <v-flex xs12 sm4>
        <v-img
            :src="require('../assets/collage 3.jpg')"
            class="elevation-10"
            >
        </v-img>
      </v-flex>




    </v-layout>

  </v-container>
</template>
<script>
  export default {
    computed: {
      size () {
        const binding = {}
        if (this.$vuetify.breakpoint.xsOnly) binding.column = true
        return binding
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/photos.vue